angular.module('taric.customsOffices', [])
    .config(['$routeProvider', routeConfigurator])
    // Components
    .component('customsOfficeSearchPage', require('./components/customs-office-search-page'))
    .component('customsOfficeForm', require('./components/customs-office-form'))
    .component('customsOfficeDetails', require('./components/customs-office-details'))
    .component('customsOfficeList', require('./components/customs-office-list'))    
    .component('customsOfficeRolePicker', require('./components/role-picker'))
    // Filters
    .filter('roleCodeTypeahead', require('./filters/role-code-typeahead-filter'))
    //Modals
    .factory('roleSelectorModal', require('./modals/role-selector'))
    .factory('countryHolidayModal', require('./modals/country-holiday-modal'))
    // Services
    .factory('customsOfficeDataService', require('./services/customs-office-data'))
    ;

function routeConfigurator($routeProvider) {
    $routeProvider
        .when('/customs-offices', {
            reloadOnSearch: false,
            showSearchSubNav: false, 
            template: '<customs-office-search-page></customs-office-search-page>',
        })
        .when('/customs-offices/:referenceNumber', {
            reloadOnSearch: false,
            showSearchSubNav: false, 
            template: '<customs-office-search-page></customs-office-search-page>',
        })
        ;
}